<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'INC-'+IncidentId+' [Override Incident Edit Lock] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item active"><i class="fa fa-stethoscope"></i> Incidents</li>
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/incidents/view/${IncidentId}`">
                            <incident-name :incident="incident" />
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-unlock"></i> Override Edit Lock
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-md-6 col-lg-5">
                    <div class="card">
                        <div class="card-header">
                            Override Incident Edit Lock
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <p>Current User Editing: <a :href="`mailto:${incident.editor.email}`">{{ incident.editor.FirstName }} {{ incident.editor.LastName }}</a> at {{ incident.editing_timestamp | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</p>
                                <strong>Note:</strong> You are about to clear out the Edit Lock for Incident:<br/><incident-name :incident="incident" />.

                                <p>If the user above is actively editing this incident, removing the lock does not remove their changes, but it may allow another user to lock them out and prevent subsequent edits.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-sm btn-warning" v-on:click="postOverride()">
                <i class="fa fa-unlock"></i> Override Edit Lock
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                IncidentId: this.$route.params.id,
                incident: {},
            }
        },

        computed: {
            appliedFilter(){
                return this.$store.state.appliedFilter;
            }
        },

        methods: {
            //Get the Incident
            getIncident(){
                //Send it
                this.$http
                    .get('/incident/edit/'+this.IncidentId)
                    .then(response => {
                        //Set all the data
                        this.incident = response.data.incident;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            //Get the Incident
            postOverride(){
                //Send it
                this.$http
                    .post('/incident/edit/'+this.IncidentId+'/override')
                    .then(response => {
                        //Send back to edit
                        this.$router.push('/incidents/view/'+this.IncidentId);

                        //Alert the user
                        this.$toastr.success('Incident Edit Lock Overwritten');
                    })
                    .catch(response => {

                    });
            },
        },

        mounted(){
            //Fetch
            this.getIncident();
        },
    }
</script>
